import React from "react";
import { Link } from "react-router-dom";

const PatientDetailsBreadcrumb = () => {
  return (
    <nav className="breadcrumb-container d-none d-md-block py-3 mb-2" aria-label="breadcrumb">
      <ol className="breadcrumb fs-sm mb-0">
        <li className="breadcrumb-item">
          <Link to="/admin/dashboard">Dashboard</Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/admin/clinicalmanagement/patients">Patients</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Treatment
        </li>
      </ol>
    </nav>
  );
};

export default PatientDetailsBreadcrumb;
